import { z } from 'zod';
import { objectId, timestampFields, FieldMetadata } from './base';

/**
 * Assignment Schema
 * A per-game/per-event duty (snacks, carpool, scorekeeper) assigned to a
 * roster Player by a team manager or admin. Exactly one of `game`/`teamEvent`
 * (controller-enforced). `completed` may be toggled by the assignee's owner.
 */
export const AssignmentSchema = z.object({
  _id: objectId,
  divisionTeam: objectId,
  game: objectId.optional(),
  teamEvent: objectId.optional(),
  title: z.string().min(1).max(80),
  player: objectId,
  note: z.string().max(500).optional(),
  createdBy: objectId.optional(),
  completed: z.boolean().optional(),
  ...timestampFields,
});

export type Assignment = z.infer<typeof AssignmentSchema>;

export const assignmentMetadata: Record<string, FieldMetadata> = {
  _id: { hidden: true },
  divisionTeam: { ref: 'DivisionTeam', label: 'Team' },
  game: { ref: 'Game', label: 'Game' },
  teamEvent: { ref: 'TeamEvent', label: 'Event' },
  title: { label: 'Duty' },
  player: { ref: 'Player', label: 'Assignee' },
  note: { label: 'Note' },
  createdBy: { ref: 'User', label: 'Created By' },
  completed: { label: 'Completed' },
  created: { hidden: true },
  updated: { hidden: true },
};
